module.exports = __webpack_public_path__ + "static/media/availability_comparative_per_wtg.74009135.svg";